export default __webpack_public_path__ + "static/media/ff.b76319f5.jpg";